// extracted by mini-css-extract-plugin
export default {"mCard":"Mw-z","image":"Nw-z","imageNoBackground":"Ow-z","fullWidth":"Pw-z"};